import WhoWeArePage from './WhoWeArePage';

export default WhoWeArePage;
